import React from 'react';
import { motion } from 'framer-motion';
import LottiePlayer from './LottiePlayer';

/**
 * Background glow using the new gradient Lottie.
 * Appears AFTER user message flies up.
 */
export default function GlowEffect() {
  return (
    <motion.div
      data-testid="glow-effect"
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: 2,
        pointerEvents: 'none',
        overflow: 'hidden',
        mixBlendMode: 'screen', 
      }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <LottiePlayer
        src="/animations/glow_new.json"
        loop={false}
        autoplay
        speed={0.5}
        style={{
          position: 'absolute',
          top: '-10%', left: '-10%',
          width: '120%', height: '120%',
          opacity: 0.8,
        }}
        testId="lottie-bg-glow"
      />
    </motion.div>
  );
}
